import { useFormikContext } from 'formik';
import React from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

export default function SubmitButton({ submitForm, saveTitle, showCalculateButton, settlementID }) {
  const { setSubmitting, isSubmitting, validateForm } = useFormikContext();
  const history = useHistory();
  const handleToList = () => {
    localStorage.removeItem('settlementForm');
    history.push('/settlement_simulator');
  };
  return (
    <>
      <Row className="d-flex justify-content-end my-3">
        <Col md={2} xl={2} lg={2} xs={12} className="pb-2">
          <Button block variant="outline-info" onClick={handleToList}>
            Cancelar
          </Button>
        </Col>
        <Col md={2} xl={2} lg={2} xs={12}>
          <Button
            block
            variant="primary"
            onClick={() => {
              setSubmitting(true);
              submitForm();
            }}
            disabled={isSubmitting}
          >
            {saveTitle || 'Calcular'}
          </Button>
        </Col>
        {showCalculateButton && (
          <Col md={2} xl={2} lg={2} xs={12}>
            <Button
              block
              variant="primary"
              onClick={() => {
                setSubmitting(true);
                if (settlementID && validateForm()) {
                  history.push(`/settlement_simulator/${settlementID}/summary`);
                }
                if (!settlementID) {
                  history.push(`/settlement_simulator`);
                }
              }}
              disabled={isSubmitting || !settlementID}
            >
              {'Siguiente'}
            </Button>
          </Col>
        )}
      </Row>
    </>
  );
}
